import { render, staticRenderFns } from "./DiagnosticBuilderChildren.vue?vue&type=template&id=44415dc4&scoped=true&"
import script from "./DiagnosticBuilderChildren.vue?vue&type=script&lang=js&"
export * from "./DiagnosticBuilderChildren.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticBuilderChildren.vue?vue&type=style&index=0&id=44415dc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44415dc4",
  null
  
)

export default component.exports